import React, { FC, useEffect, useState } from 'react';
import { useStore } from '@/app/providers/StoreProvider';
import { Input } from 'antd';
import { useDebounce } from '@/shared/hooks/useDebounce';
import { SearchTeamsList } from './SearchTeamsList';
import ImgSearch from '@/shared/pictures/search.svg';


export const SearchTeams:FC = () => {

  const {teamStore} = useStore();
  const {clearSearchTeams, getSearchTeams} = teamStore;
  const [name,setName] = useState<string>('');
  const debouncedQuery = useDebounce(name, 500);

  useEffect(() => {
    if (debouncedQuery) {
      if(debouncedQuery.length > 2) getSearchTeams(debouncedQuery);
    }
  }, [debouncedQuery]);

  const handleSearch = (e:React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
    if(e.target.value.length === 0) clearSearchTeams();
  }

  const SearchImg = () =>{
    return (
      <img src={ImgSearch} alt="search" />
    );
  }

  return (
    <div className='search-teams'>
      <Input className='search-teams_input' placeholder="Великая команда" onChange={handleSearch} value={name} prefix={<SearchImg/>}/>
      <SearchTeamsList/>
    </div>
  );

};